/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SurveyQuestions = {
    type: 'array',
    contains: {
        type: 'ResponseSurveyQuestion',
    },
};